import { getContext } from '@fiverr-private/fiverr_context';
import { bigQuery } from '@fiverr-private/obs';

export const sendBigQuery = (event) => {
    const { userGuid, userId } = getContext();

    const staticEnrichment = {
        user: { id: userId, uid: userGuid },
        uid: userGuid,
    };

    bigQuery.send({
        ...event,
        ...staticEnrichment,
    });
};
